<template>
    <div>
        <page-header :title="title" :breadcrumbs="breadcrumbs" />

        <div class="card">
            <div class="card-body">
                <div class="mb-2">
                    <button
                        class="btn btn-success waves-effect waves-light"
                        @click="showAddModal"
                    >
                        <i class="fas fa-plus-circle" />
                        Add Media
                    </button>
                </div>
                <preview
                    :key="mediaKey"
                    is-deletable
                    @on-select-media="selectMedia"
                    @on-delete-media="showDeleteModal"
                />
            </div>
        </div>

        <create-edit-modal
            :media-to-edit="mediaToEdit"
            @hide="mediaToEdit = null"
            @fetch-media="fetchMedia"
            @updated="onMediaUpdated"
        />

        <confirmation-modal
            :content="'Do you want to delete this media?'"
            @agree="removeMedia"
            @disagree="idToDelete = null"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { StatusCodes as HTTP } from 'http-status-codes';
import Preview from '@/components/media/Preview';
import CreateEditModal from '@/components/media/CreateEditModal';
import ConfirmationModal from '@/components/elements/ConfirmationModal';

export default {
    page: {
        title: 'Media'
    },

    components: {
        CreateEditModal,
        ConfirmationModal,
        Preview
    },

    data() {
        return {
            title: 'Media',
            breadcrumbs: [
                {
                    text: 'Cancer',
                    to: '/'
                },
                {
                    text: 'Media',
                    active: true
                }
            ],
            mediaToEdit: null,
            mediaKey: 0,
            idToDelete: null,
            updateTime: 0
        };
    },

    methods: {
        ...mapActions({
            deleteMedia: 'media/delete'
        }),

        fetchMedia() {
            this.mediaKey++;
        },

        showAddModal() {
            this.$bvModal.show('modalCreateEdit');
        },

        selectMedia(media) {
            this.mediaToEdit = media[0];
            this.$bvModal.show('modalCreateEdit');
        },

        showDeleteModal(id) {
            this.idToDelete = id;
            this.$bvModal.show('confirmModal');
        },

        async removeMedia() {
            try {
                await this.deleteMedia(this.idToDelete);

                this.idToDelete = null;
                this.fetchMedia();

                this.$toaster('Media has been deleted!');
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.UNPROCESSABLE_ENTITY && data) {
                        this.$toasterError(data);

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        },

        onMediaUpdated(media) {
            this.mediaToEdit = { ...media };
            this.mediaKey++;
        }
    }
};
</script>
